AFRAME.registerComponent('particle-explosion', {
  schema: {
    particleCount: { type: 'number', default: 20  },
    duration:      { type: 'number', default: 800 },
    spread:        { type: 'number', default: 2.5 },
  },

  init: function () {
    this._particles = [];
    this._startTime = null;
    this._done      = false;

    // Prototype-validated colors — 6 vivid hues that read clearly in VR
    const COLORS = ['#ff4444', '#ffaa00', '#ffff44', '#ff6600', '#ff88ff', '#44ffff'];
    const spread  = this.data.spread;

    for (let i = 0; i < this.data.particleCount; i++) {
      const p = document.createElement('a-entity');

      // Variable radius per particle: 20–60mm sphere.
      // Fixed radius produces a uniform "ping-pong ball" look; variation reads more organic.
      const radius = 0.02 + Math.random() * 0.04;
      p.setAttribute('geometry', 'primitive: sphere; radius: ' + radius + '; segmentsWidth: 4; segmentsHeight: 4');

      // transparent MUST be set at construction — A-Frame/Three.js cannot enable
      // transparency retroactively after the material has been created.
      p.setAttribute('material', {
        color:       COLORS[i % COLORS.length],
        transparent: true,
        opacity:     1.0,
        shader:      'flat',
      });

      this.el.appendChild(p);

      // Box velocity distribution with +0.5 upward bias — particles arc upward
      // rather than distributing evenly into the floor.
      this._particles.push({
        el:   p,
        mesh: null, // lazy-cached on first tick after Three.js creates the mesh
        vel:  {
          x: (Math.random() - 0.5) * spread * 2,
          y: (Math.random() - 0.5) * spread * 2 + 0.5,
          z: (Math.random() - 0.5) * spread * 2,
        },
      });
    }
  },

  tick: function (time, delta) {
    if (this._done) { return; }

    // Use A-Frame's scene-relative `time` (not Date.now()) so explosions pause
    // correctly when the browser tab is hidden or the VR session is suspended.
    if (this._startTime === null) {
      this._startTime = time;
    }

    const elapsed  = time - this._startTime;
    const duration = this.data.duration;

    if (elapsed >= duration) {
      this._done = true;
      // Third arg is bubbles = false — prevents propagation to parent entities.
      // letter-click listens directly on this entity with { once: true }.
      this.el.emit('explosion-complete', null, false);
      this.el.parentNode && this.el.parentNode.removeChild(this.el);
      return;
    }

    const progress = elapsed / duration;
    const dtSec    = delta / 1000; // ms → seconds

    for (const p of this._particles) {
      // Lazy-cache mesh reference — getObject3D returns null for the first tick or
      // two while A-Frame creates the geometry/material. Skip until ready.
      if (!p.mesh) {
        p.mesh = p.el.getObject3D('mesh');
        if (!p.mesh) { continue; }
      }

      // Direct Three.js writes — NO setAttribute in tick().
      // setAttribute routes through A-Frame's full component pipeline on every call.
      // 20 particles × 72 FPS = 1,440 pipeline invocations/sec — causes frame drops on Quest 2.
      p.vel.y -= 3.0 * dtSec;  // gravity: 3 m/s² downward acceleration
      p.el.object3D.position.x += p.vel.x * dtSec;
      p.el.object3D.position.y += p.vel.y * dtSec;
      p.el.object3D.position.z += p.vel.z * dtSec;

      const s = 1.0 - progress;  // shrinks to 0 at completion
      p.el.object3D.scale.set(s, s, s);
      p.mesh.material.opacity = 1.0 - progress;
    }
  },

  remove: function () {
    // Dispose Three.js geometry and material for every particle.
    // Called by A-Frame when the explosion entity is removed from the DOM.
    // Prevents geometry/material accumulation across many explosions.
    for (const p of this._particles) {
      if (p.mesh) {
        p.mesh.geometry && p.mesh.geometry.dispose();
        p.mesh.material && p.mesh.material.dispose();
      }
    }
    this._particles = [];
  },
});

if (import.meta.hot) { import.meta.hot.decline(); }
